import { differenceInDays, format as onFormat } from 'date-fns';
import { format as timeAgoFormat } from 'timeago.js';

export const getHumanReadbleDateString = (date: Date): string =>
  differenceInDays(new Date(), date) < 7
    ? ` ${timeAgoFormat(date)}`
    : ` on ${onFormat(date, 'MMM d, y')}`;
